import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge, taught about this project's named z-index scale.
 *
 * The stock instance only understands numeric/arbitrary z utilities, so it
 * cannot tell that `z-modal` and `z-confirm` are the same property:
 *
 *   twMerge('fixed z-modal', 'z-confirm')  ->  'fixed z-modal z-confirm'
 *
 * Both classes survive and CSS source order decides the winner, which is
 * how a confirmation dialog passed `z-confirm` (250) still rendered behind
 * a `z-dropdown` (100) popover — it was silently being drawn at z-modal
 * (30). Every `containerStyle="z-nested"` popup had the same latent bug.
 *
 * Keep the list in sync with tailwind.config.js theme.extend.zIndex and
 * src/zIndex.ts.
 */
export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      z: [{ z: ['modal', 'nested', 'dropdown', 'tooltip', 'overlay', 'confirm', 'onboarding'] }],
    },
  },
})
